import { isNull } from "lodash";

function getOrderStatus(work_order)
{
  if (work_order?.status === 'cancelled' && work_order?.bill_for_cancelization) {
    return "cancelled_billable";
  } else if (work_order?.status === 'cancelled' && !work_order?.bill_for_cancelization) {
    return "cancelled_non_billable";
  } else if (isNull(work_order.work_order_number) || work_order?.status === 'tentative') {
    return "forecast";
  } else if (work_order?.status === 'technician_assigned' || work_order?.status === 'technician_en_route') {
    return "scheduled";
  } else {
    return work_order.status;
  }
}

function getInvoiceStatus(work_order)
{
  if(work_order.is_auto_invoice_genrated || work_order.is_manual_invoice_generated)
  {
    return 'Invoiced';
  }
  else
  {
    return 'To be invoiced'
  }
}

export const WorkOrderWrapper = (data) =>
{
  const results = data.results.map(item => {
    return {
      work_order_number: item?.work_order_number,
      user: `${item?.service_order?.user?.first_name} ${item?.service_order?.user?.last_name}`,
      user_role: item?.service_order?.user?.role[0],
      user_uuid: item?.service_order?.user?.uuid,
      customer_type: item?.service_order?.service_type,
      work_order_uuid: item?.uuid,
      service_order: item?.service_order?.service_order_number,
      service_date: item?.scheduled_time,
      billing_type: item?.service_order?.user?.is_email_invoice? "Email" : "Print",
      amount_due: item?.amount_due,
      service_uuid: item?.service_order?.uuid,
      service : item?.service_order,
      status: getOrderStatus(item),
      invoice_status: getInvoiceStatus(item)
    }
	  });

  return {...data, results}
} 